/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {getters} from '@/store/modules/community-challenges/getters';
import {actions} from '@/store/modules/community-challenges/actions';
import {mutations} from '@/store/modules/community-challenges/mutations';
import {CommunityChallengesState, CommunityChallengesStateInterface} from '@/store/modules/community-challenges/types';

/**
 * The community challenges store module.
 * This module is imported by vuex as a representation of the animals.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export const state: CommunityChallengesStateInterface = new CommunityChallengesState();

const namespaced: boolean = true;

export const communityChallengesModule: Module<CommunityChallengesStateInterface, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
